import L from 'leaflet';

interface Store {
    uuid: string;
    name: string;
    latitude: number;
    longitude: number;
}

interface ClosestStore extends Store {
    distance: number;
}

const LIMIT = 20; // in meters

export const getClosestStore = (
    userLat: number,
    userLng: number,
    stores: Store[],
    excludeUuids: string[],
): ClosestStore | null => {
    const userLocation = L.latLng(userLat, userLng);
    
    const filteredStores = stores.filter(store => !excludeUuids.includes(store.uuid));

    const closest = filteredStores.reduce<ClosestStore | null>((closest, store) => {
        const storeLocation = L.latLng(store.latitude, store.longitude);
        // in meters
        const distance = userLocation.distanceTo(storeLocation);
        
        if (!closest || distance < closest.distance) {
            return { ...store, distance };
        }
        return closest;
    }, null);

    return closest && closest.distance <= LIMIT ? closest : null;
};
